import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RichEditorState } from "../types/index.js";

const initialState: RichEditorState = {};

const slice = createSlice({
  name: "richEditor",
  initialState,
  reducers: {
    setEditorActiveState: (
      state,
      {
        payload: { moduleId, isActive },
      }: PayloadAction<{ moduleId: string; isActive: boolean }>,
    ) => {
      state[moduleId] = isActive;
    },
  },
});

export const { setEditorActiveState } = slice.actions;

export default slice.reducer;
